import DateFilter from "./date-filter";

export default function LastEditedDateFilter({lastEditedStart,
    lastEditedEnd, onChange} : any) {    
    return (
        <DateFilter label="Last Edited" startDate={lastEditedStart} endDate={lastEditedEnd} onChange={onChange}/>
    )
}